<template>
    <div>
        <emp-dialog-selector
            v-model="dialogVisible"
            :multiple="multiple"
            :loading="dialogLoading"
            :group-data="selectorData"
            :sidebar-list="sidebarData"
            :default-checked-keys="defaultCheckedKeys"
            :shortcutVisible="shortcutVisible"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem">
        </emp-dialog-selector>
    </div>
</template>
<script>
import UtilsMixins from '@/mixins/utils'
import EmpDialogSelector from './emp-dialog-selector.vue'
export default {
    name: 'empDialogSelectorInstance',
    mixins: [UtilsMixins],
    components: {
        EmpDialogSelector,
    },
    data() {
        return {
            dialogLoading: false,
            defaultCheckedKeys: [],
            dialogVisible: false,
            selectorData: null,
            sidebarData: null,
            multiple: true,
            title: undefined,
            shortcutVisible: false,
            filterEmpData: undefined
        }
    },
    methods: {
        show(params) {
            const { loadData, defaultCheckedKeys, multiple , title, shortcutVisible, filterEmpData } = params;
            if (multiple !== undefined) {
                this.multiple = multiple;
            }
            if (shortcutVisible !== undefined) {
                this.shortcutVisible = shortcutVisible;
            }
            if (filterEmpData !== undefined) {
                this.filterEmpData = filterEmpData;
            }
            this.title = title || '请选择员工';

            this.defaultCheckedKeys = defaultCheckedKeys;
            if (loadData) {
                this.dialogLoading = true;
                loadData(this.loadDataCallback);
            }
            this.dialogVisible = true;
        },
        onConfirm(data, shortcutValue) {
            this.resolve({
                selectValue: data,
                shortcutValue,
            });
        },
        onSelectItem(data) {
            this.resolve(data);
        },
        loadAdminAndEmployeeData(data) {
            const { adminList, empList } = data;
            const shopIdMap = {};
            const roleMap = {};
            const roleGroupDataMap = {};
            const sidebarList = [];
            let listData = [];
            if (adminList && adminList.length > 0) {
                listData = listData.concat(adminList)
            }
            if (empList && empList.length > 0) {
                listData = listData.concat(empList);
            }
            listData.forEach(empData => {
                const { shopid, shopId, shopName, roleStr } = empData;
                const empShopId = Number(shopid || shopId);
                empData.shopId = Number(empShopId);
                if (!this.filterEmpData || this.filterEmpData(empData)) {
                    const groupId = `${empShopId}-${roleStr}`;
                    empData.groupId = groupId;
                    if (empData.type === 0) {
                        empData.status = 1;
                    }
                    roleMap[groupId] = {
                        name: roleStr,
                        id: groupId
                    }
                    if (!roleGroupDataMap[groupId]) {
                        roleGroupDataMap[groupId] = [];
                    }
                    roleGroupDataMap[groupId].push(empData);
                    if (!shopIdMap[empShopId]) {
                        sidebarList.push({
                            id: empShopId,
                            osname: shopName,
                        })
                        shopIdMap[empShopId] = 1;
                    }
                }
            })

            const contentData = Object.keys(roleMap).map(groupId => {
                const groupData = roleMap[groupId];
                groupData.children = roleGroupDataMap[groupId];
                return groupData;
            })
            this.dialogLoading = false;
            this.selectorData = contentData;
            this.sidebarData = sidebarList;
        },
        loadDataCallback(listData, options) {
            if (options && options.hasAdmin) {
                    this.loadAdminAndEmployeeData(listData);
                    return;
            }
            let sidebarList = [];
            let shopIdMap = {};
            let contentData = [];
            if (listData.level === 2) {
                listData = {
                    children: [ {
                        children: [listData]
                    }]
                }
            }
            listData.children.forEach(areaData => {
                if (areaData.children) {
                    areaData.children.forEach(shopData => {
                        const { id, children } = shopData;
                        shopData.viewName = this.getShopNameByData(shopData);
                        if (children && !shopIdMap[id]) {
                            const shopChildren = children.reduce((listData, departmentData) => {
                                const children = departmentData.children || [];
                                const filterChildren = children.filter(posData => {
                                    posData.id = `${posData.shopId}-${posData.id}`;
                                    let { children: posChildren } = posData;
                                    if (posChildren && posChildren.length > 0) {
                                        posChildren = posChildren.filter(empData => {
                                            empData.barberLevelName = posData.name;
                                            empData.groupId = posData.id;
                                            return !this.filterEmpData || this.filterEmpData(empData)

                                        })
                                        if (posChildren.length > 0) {
                                            return true;
                                        }
                                    }
                                })
                                listData.push(...filterChildren);
                                return listData;
                            }, []);
                            if (shopChildren.length) {
                                shopIdMap[id] = 1;
                                sidebarList.push({
                                    osname: shopData.viewName,
                                    id,
                                })
                                contentData.push(...shopChildren);
                            }
                        }
                    })
                }
            })
            this.dialogLoading = false;
            this.selectorData = contentData;
            this.sidebarData = sidebarList;
        },
    },

}
</script>